// ============ RENKLER ============
export const primaryColor = "#2697FF";
export const primaryDark = "#045781";
export const secondaryColor = "#2A2D3E";
export const accentColor = "#A5AF67";
export const bgColor = "#212332";

export const color1 = "#F3F2F7";
export const color2 = "#CDE3F9";
export const color3 = "#3F51B5";
export const titleColor = "#0D47A1";

// Durum renkleri
export const successColor = "#22C55E";
export const successColor2 = "#266702";
export const warningColor = "#F59E0B";
export const warningSoft = "#FEF3C7";
export const errorColor = "#EF4444";
export const infoColor = "#0EA5E9";

// Metin
export const textPrimary = "#1E293B";
export const textSecondary = "#64748B";

// ============ GRADIENT'LER ============
export const bgGradient = `linear-gradient(135deg, ${primaryColor} 0%, ${accentColor} 100%)`;
export const iconGradient = `linear-gradient(135deg, ${primaryDark} 0%, ${accentColor} 100%)`;
export const buttonGradient = `linear-gradient(135deg, ${primaryDark} 0%, ${accentColor} 100%)`;
export const buttonGradientHover = `linear-gradient(135deg, #033d5c 0%, #8d9757 100%)`;

// ============ GÖLGELER ============
export const cardShadow = "0 20px 60px rgba(0,0,0,0.25)";
export const softShadow = "0 2px 12px rgba(0,0,0,0.06)";
export const iconShadow = `0 8px 20px ${primaryColor}66`;
export const buttonShadow = `0 4px 15px ${primaryDark}55`;
export const buttonShadowHover = `0 6px 20px ${primaryDark}88`;

// ============ API ============
// export const myApi = "https://destek.nortek.com.tr/nortek_manager_app";
// export const myApi = "https://nortek.appdia.tr/api";

export const myApi = "https://destek.nortek.com.tr/api";

// ============ UYGULAMA ============
export const version = "V 2.0.3";
export const timerValue = 1;
export const POLLING_INTERVAL_MS = 10000;
// ============ ADMIN PANEL ============
export const adminBgGradient =
  "linear-gradient(135deg, #1e293b 0%, #2a2d3e 60%, #3a3d52 140%)";
// ============ LAYOUT ============
export const defaultPadding = 16;
export const cardMaxWidth = 440;
export const cardBorderRadius = 16;

// ============ STORAGE ============
export const STORAGE_KEYS = {
  USER: "nortek_user",
  TOKEN: "nortek_token",
  REMEMBER: "nortek_remember",
  SUNUCU_KODU: "nortek_sunucu_kodu",
  USER_TYPE: "nortek_user_type",
  USERNAME: "nortek_username",
  PANEL: "nortek_panel",
};

// ============ KULLANICI TİPLERİ ============
export const USER_TYPES = {
  ADMIN: "admin",
  CUSTOMER: "customer",
  SUPPORT: "support",
};
// Admin sidebar item'ları (gruplandırılmış)
export const ADMIN_NAV = [
  {
    key: "home",
    label: "Ana Sayfa",
    icon: "home",
    path: "/admin",
    children: [{ label: "Dashboard", path: "/admin", sub: "dashboard" }],
  },
  {
    key: "companies",
    label: "Sunucular",
    icon: "badge",
    children: [
      { label: "Sunucu Listesi", path: "/admin/companies" },
      { label: "Sunucu Ekle", path: "/admin/companies/add" },
    ],
  },
  {
    key: "supports",
    label: "Destek Talepleri",
    icon: "support",
    children: [
      { label: "Talep Listesi", path: "/admin/supports" },
      { label: "Destek Talebi Ekle", path: "/admin/supports/add" },
    ],
  },
  {
    key: "edu",
    label: "Eğitim",
    icon: "school",
    children: [
      { label: "Eğitim Listesi", path: "/admin/edu" },
      { label: "Eğitim Ekle", path: "/admin/edu/add" },
    ],
  },
  {
    key: "users",
    label: "Kullanıcılar",
    icon: "people",
    children: [
      { label: "Kullanıcı Listesi", path: "/admin/users" },
      { label: "Kullanıcı Ekle", path: "/admin/users/add" },
    ],
  },
  {
    key: "knowledge",
    label: "Bilgi Bankası",
    icon: "info",
    children: [
      { label: "Makale Listesi", path: "/admin/knowledge" },
      { label: "Yeni Makale Ekle", path: "/admin/knowledge/add" },
    ],
  },
  {
    key: "notifications",
    label: "Duyurular",
    icon: "notifications",
    children: [
      { label: "Duyuru Listesi", path: "/admin/notifications" },
      { label: "Duyuru Ekle", path: "/admin/notifications/add" },
    ],
  },
];
// ============ ROUTES ============
export const ROUTES = {
  SPLASH: "/",
  LOGIN: "/login",

  // Müşteri (rootuser + user)
  CUSTOMER_HOME: "/customer",
  CUSTOMER_SUPPORT: "/customer/support",
  CUSTOMER_SETTINGS: "/customer/settings",
  CUSTOMER_EDU: "/customer/edu",
  CUSTOMER_INFO: "/customer/info",
  CUSTOMER_NOTIFICATIONS: "/customer/notifications",

  // Destek personeli
  SUPPORTER_HOME: "/supporter",
  SUPPORTER_CANCELLED: "/supporter/cancelled",
  SUPPORTER_COMPLETED: "/supporter/completed",

  // Admin
  ADMIN_HOME: "/admin",
  // ADMIN_CANCELLED: "/admin/cancelled",
  // ADMIN_COMPLETED: "/admin/completed",
  ADMIN_COMPANIES: "/admin/companies",
  ADMIN_COMPANIES_ADD: "/admin/companies/add",
  ADMIN_SUPPORTS: "/admin/supports",
  ADMIN_SUPPORTS_ADD: "/admin/supports/add",
  ADMIN_EDU: "/admin/edu",
  ADMIN_EDU_ADD: "/admin/edu/add",
  ADMIN_USERS: "/admin/users",
  ADMIN_USERS_ADD: "/admin/users/add",
  ADMIN_KNOWLEDGE: "/admin/knowledge",
  ADMIN_KNOWLEDGE_ADD: "/admin/knowledge/add",
  ADMIN_NOTIFICATIONS: "/admin/notifications",
  ADMIN_NOTIFICATIONS_ADD: "/admin/notifications/add",
};

// ============ ORDERS ============
export const ORDER_STATUS = {
  POOL: "Gönderildi",
  IN_PROGRESS: "işlemde",
  PENDING: "Beklemede",
  COMPLETED: "Tamamlandı",
  CANCELLED: "cancel",
};

// Kanban kolon renkleri (Flutter _columns ile aynı)
export const KANBAN_COLUMNS = [
  {
    key: "pool",
    title: "Talep Havuzu",
    status: "Gönderildi",
    accent: "#E67E22",
    bg: "#FFCC80",
    icon: "inbox",
  },
  {
    key: "progress",
    title: "Kabul Edilenler",
    status: "işlemde",
    accent: "#1976D2",
    bg: "#90CAF9",
    icon: "engineering",
  },
  {
    key: "pending",
    title: "Askı",
    status: "Beklemede",
    accent: "#C62828",
    bg: "#EF9A9A",
    icon: "pause",
  },
  {
    key: "completed",
    title: "Tamamlandı",
    status: "Tamamlandı",
    accent: "#2E7D32",
    bg: "#A5D6A7",
    icon: "check",
  },
];
// ============ SUPPORTER PANEL ============
export const supporterBgGradient =
  "linear-gradient(135deg, #0d6a9e 0%, #2d4359 55%, #7a8aa0 130%)";
// ============ MESAJLAR ============
export const MESSAGES = {
  // Login
  LOGIN_TITLE: "Hoş Geldiniz",
  LOGIN_SUBTITLE: "Devam etmek için hesabınıza giriş yapın",
  USERNAME_LABEL: "Kullanıcı Adı",
  PASSWORD_LABEL: "Şifre",
  REMEMBER_ME: "Beni hatırla",
  FORGOT_PASSWORD: "Şifremi unuttum",
  LOGIN_BUTTON: "Giriş Yap",
  NO_ACCOUNT: "Hesabınız yok mu?",
  REGISTER: "Kayıt Olun",
  OR: "veya",
  REQUIRED_FIELDS: "Lütfen kullanıcı adı ve şifre giriniz.",
  CONNECTION_ERROR: "Sunucuya bağlanılamadı. Lütfen tekrar deneyin.",
  SUCCESS_DEFAULT: "Giriş başarılı! Yönlendiriliyorsunuz...",

  // Customer Home
  // HOME_APPBAR: "Ana Sayfa",
  HOME_TITLE: "Nortek Destek Portalı",
  HOME_SUBTITLE:
    "Destek taleplerinizi, eğitim içeriklerini ve bilgi bankasını tek yerden yönetin.",
  CONTRACT_WARNING:
    "Destek sözleşmeniz bulunmadığı için talepleriniz ücretli olarak değerlendirilecektir.",
  STAT_ACTIVE_USER: "Aktif kullanıcı",
  STAT_SUNUCU_KODU: "Sunucu kodu",
  STAT_PORTAL_STATUS: "Portal durumu",
  STAT_PORTAL_ACTIVE: "Aktif",
  STAT_ACCOUNT: "Hesabım",

  // Action cards
  ACTION_SUPPORT: "Destek Hizmeti",
  ACTION_SUPPORT_SUB: "Yeni destek talebi açın, aktif görüşmeleri takip edin.",
  ACTION_EDU: "Eğitim Listesi",
  ACTION_EDU_SUB: "Planlanan eğitimleri, eğitmen ve süre bilgileriyle görün.",
  ACTION_INFO: "Bilgi Bankası",
  ACTION_INFO_SUB: "Sık kullanılan çözümler ve rehberlere hızlı erişin.",

  // Errors
  CONTRACT_LOAD_ERROR: "Şirket bilgileri yüklenemedi.",

  SETTINGS_APPBAR: "Ayarlar",
  SETTINGS_TITLE: "Kişisel bilgiler",
  SETTINGS_USERNAME: "Kullanıcı Adı",
  SETTINGS_EMAIL: "Email",
  SETTINGS_PHONE: "Telefon",
  SETTINGS_SUNUCU_KODU: "Sunucu kodu",
  SETTINGS_PASSWORD: "Şifre",
  SETTINGS_PASSWORD_HINT: "Yeni şifre (boş bırakırsanız değişmez)",
  SETTINGS_EDIT: "Düzenle",
  SETTINGS_LOGOUT: "Çıkış",
  SETTINGS_LOAD_ERROR: "Kullanıcı bilgileri yüklenemedi.",
  SETTINGS_UPDATE_SUCCESS: "Bilgileriniz başarıyla güncellendi.",
  SETTINGS_UPDATE_ERROR: "Bilgiler güncellenemedi.",
  SETTINGS_REFRESH: "Yenile",

  // Education / Eğitim
  EDU_APPBAR: "Eğitim Listesi",
  EDU_TITLE: "Eğitim Listesi",
  EDU_SUBTITLE:
    "Planlanan eğitimleri tarih, eğitmen ve süre bilgileriyle takip edin.",
  EDU_SEARCH_PLACEHOLDER: "Eğitim adı veya eğitmen",
  EDU_EMPTY_TITLE: "Eğitim bulunamadı",
  EDU_EMPTY_MESSAGE: "Aramanıza uygun eğitim kaydı yok.",
  EDU_LOAD_ERROR: "Eğitimler yüklenemedi. Lütfen tekrar deneyin.",
  // Information Bank / Bilgi Bankası
  INFO_APPBAR: "Bilgi Bankası",
  INFO_TITLE: "Bilgi Bankası",
  INFO_SUBTITLE: "Sık kullanılan çözümler ve rehberlere hızlı erişin.",
  INFO_SEARCH_PLACEHOLDER: "Konu veya anahtar kelime",
  INFO_EMPTY_TITLE: "Kayıt bulunamadı",
  INFO_EMPTY_MESSAGE: "Aramanıza uygun bilgi bankası kaydı yok.",
  INFO_LOAD_ERROR: "Bilgi bankası yüklenemedi. Lütfen tekrar deneyin.",

  // Notifications / Duyurular
  NOTIFICATION_APPBAR: "Duyurular",
  NOTIFICATION_TITLE: "Duyurular",
  NOTIFICATION_SUBTITLE:
    "Sistem duyuruları, kampanyalar ve güncellemeler hakkında bilgi alın.",
  NOTIFICATION_EMPTY_TITLE: "Duyuru yok",
  NOTIFICATION_EMPTY_MESSAGE: "Şu anda görüntülenecek bir duyuru bulunmuyor.",
  NOTIFICATION_LOAD_ERROR: "Duyurular yüklenemedi.",
  NOTIFICATION_REFRESH: "Yenile",
  // Splash
  SPLASH_LOADING: "Yükleniyor...",
  SPLASH_BRAND: "Nortek",
  SPLASH_TAGLINE: "Destek Portalı",

  // Support / Destek
  SUPPORT_APPBAR: "Destek Listesi",
  SUPPORT_TITLE: "Destek Listesi",
  SUPPORT_SUBTITLE:
    "Destek taleplerinizi görüntüleyin, durumlarını takip edin.",
  SUPPORT_TAB_ACTIVE: "Aktif",
  SUPPORT_TAB_DONE: "Tamamlananlar",
  SUPPORT_STAT_TOTAL: "Toplam talep",
  SUPPORT_STAT_ACTIVE: "Aktif",
  SUPPORT_STAT_DONE: "Tamamlanan",
  SUPPORT_EMPTY_TITLE: "Kayıt bulunamadı",
  SUPPORT_EMPTY_MESSAGE: "Bu sekmede gösterilecek destek talebi yok.",
  SUPPORT_LOAD_ERROR: "Destek talepleri yüklenemedi.",
  SUPPORT_NEW_BUTTON: "Yeni talep",
  SUPPORT_NEW_DIALOG_TITLE: "Yeni destek talebi",
  SUPPORT_NEW_DIALOG_DESC:
    "Talebinizi net bir konu başlığıyla oluşturun. Mesaj ve dosyaları sonraki ekranda ekleyebilirsiniz.",
  SUPPORT_NEW_TITLE_LABEL: "Konu",
  SUPPORT_NEW_TITLE_HINT: "Örn. Terminal bağlantı sorunu",
  SUPPORT_NEW_DESC_LABEL: "Açıklama (opsiyonel)",
  SUPPORT_NEW_DESC_HINT: "Talebinizi detaylı bir şekilde açıklayın...",
  SUPPORT_VALIDATION_TITLE_MAX: "Konu en fazla 100 karakter olabilir.",
  SUPPORT_CONTRACT_CHECK:
    "Destek hizmeti karşılığında ücret ödemeyi kabul ediyorum.",
  SUPPORT_DIALOG_CLOSE: "Kapat",
  SUPPORT_DIALOG_SAVE: "Kaydet",
  SUPPORT_VALIDATION_TITLE: "Lütfen destek talebinin konusunu yazın.",
  SUPPORT_VALIDATION_CONTRACT: "Ücretli destek onayını işaretleyin.",
  SUPPORT_STATUS_SENT: "Gönderildi",
  SUPPORT_CREATE_SUCCESS: "Destek talebiniz oluşturuldu.",
  SUPPORT_CREATE_ERROR: "Destek talebi oluşturulamadı.",
  // MESSAGES'a ekle
  SUPPORTER_TITLE: "Destek Paneli",
  SUPPORTER_SUBTITLE:
    "Havuz, kabul edilen, askı ve tamamlanan talepleri yönetin.",
  SUPPORTER_SIDEBAR_HOME: "Ana Sayfa",
  SUPPORTER_SIDEBAR_CANCELLED: "İptal Edilen Talepler",
  SUPPORTER_SIDEBAR_COMPLETED: "Tamamlanan Talepler",
  SUPPORTER_STORE: "Nortek Store",
  SUPPORTER_NOTE_TITLE_PENDING: "Destek Talebini Beklet",
  SUPPORTER_NOTE_HINT_PENDING: "Bekletme Sebebini Girin",
  SUPPORTER_NOTE_TITLE_DONE: "Yapılan İşin Özeti",
  SUPPORTER_NOTE_HINT_DONE: "Yapılan İşin Özetini Girin",
  SUPPORTER_NOTE_MIN_ERROR: "Lütfen en az 6 karakter girin",
  SUPPORTER_CANCEL_TITLE: "Destek Talebini İptal Et",
  SUPPORTER_CANCEL_HINT: "İptal sebebini yazın",
  SUPPORTER_CANCEL_REQUIRED: "İptal sebebi boş bırakılamaz",
  SUPPORTER_CANCELLED_HEADER: "İptal edilen talepler",
  SUPPORTER_COMPLETED_HEADER: "Tamamlanan işlemler",
  SUPPORTER_STAT_TOTAL: "Toplam iş",
  SUPPORTER_STAT_TODAY: "Bugün tamamlanan",
  SUPPORTER_STAT_AVG: "Ortalama süre",

  ADMIN_TITLE: "Yönetim Paneli",
  ADMIN_SUBTITLE: "Nortek yönetim sistemine hoş geldiniz",
  ADMIN_LOGOUT: "Çıkış",
  ADMIN_HOME_TITLE: "Dashboard",
  ADMIN_HOME_SUBTITLE: "Genel istatistikler ve grafikler",
};
